import {CONSTANTS} from '@apps-common/ui-theme';
import {createPlanetTheme} from '@apps-common/ui-theme/Themes.js';

import {componentOverrides} from './overrides.js';

export const theme = createPlanetTheme({
  colorScheme: CONSTANTS.THEME_VARIANTS.DARK,
  extendedConfig: {
    colorSchemes: {
      light: {
        palette: {
          DataGrid: {
            headerBg: 'grey.300',
          },
        },
      },
      dark: {
        palette: {
          DataGrid: {
            headerBg: '#23343F',
          },
        },
      },
    },
    components: componentOverrides,
  },
});
